module.exports = __webpack_public_path__ + "static/media/h3.8aabb8b3.svg";